import { create } from 'zustand';
import { getCarbonAvoidanceReport } from '../services/carbon-avoidance-report.service';
import type {
  CarbonAvoidanceReportParams,
  OrganizationCarbonAvoidanceReport,
} from '../types/carbon-avoidance-report.type';

interface CarbonAvoidanceReportState {
  report: OrganizationCarbonAvoidanceReport | null;
  isLoading: boolean;
  error: string | null;
  fetchCarbonAvoidanceReport: (
    orgId: string,
    params: CarbonAvoidanceReportParams
  ) => Promise<void>;
  reset: () => void;
}

let fetchGeneration = 0;

export const useCarbonAvoidanceReportStore = create<CarbonAvoidanceReportState>((set) => ({
  report: null,
  isLoading: false,
  error: null,

  reset: () =>
    set({
      report: null,
      isLoading: false,
      error: null,
    }),

  fetchCarbonAvoidanceReport: async (orgId, params) => {
    const generation = ++fetchGeneration;
    set({ isLoading: true, error: null });

    try {
      const report = await getCarbonAvoidanceReport(orgId, params);
      if (generation !== fetchGeneration) return;
      set({ report, isLoading: false, error: null });
    } catch (err) {
      if (generation !== fetchGeneration) return;
      set({
        report: null,
        isLoading: false,
        error:
          err instanceof Error ? err.message : 'Failed to load carbon avoidance report',
      });
    }
  },
}));
